/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Session_Not_FoundInputs */

const en_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session not found.`)
};

const de_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung nicht gefunden.`)
};

const fr_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session introuvable.`)
};

const es_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión no encontrada.`)
};

const it_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessione non trovata.`)
};

const nl_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessie niet gevonden.`)
};

const pl_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesja nie została znaleziona.`)
};

const fi_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istuntoa ei löytynyt.`)
};

const da_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session ikke fundet.`)
};

const sv_interview_practice_session_not_found = /** @type {(inputs: Interview_Practice_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session hittades inte.`)
};

/**
* | output |
* | --- |
* | "Session not found." |
*
* @param {Interview_Practice_Session_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_session_not_found = /** @type {((inputs?: Interview_Practice_Session_Not_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Session_Not_FoundInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_session_not_found(inputs)
	if (locale === "fr") return fr_interview_practice_session_not_found(inputs)
	if (locale === "es") return es_interview_practice_session_not_found(inputs)
	if (locale === "it") return it_interview_practice_session_not_found(inputs)
	if (locale === "nl") return nl_interview_practice_session_not_found(inputs)
	if (locale === "pl") return pl_interview_practice_session_not_found(inputs)
	if (locale === "fi") return fi_interview_practice_session_not_found(inputs)
	if (locale === "da") return da_interview_practice_session_not_found(inputs)
	if (locale === "sv") return sv_interview_practice_session_not_found(inputs)
	return en_interview_practice_session_not_found(inputs)
});